import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonGroup, Modal as ConstellationModal, Heading, TextButton } from '@zillow/constellation-10';

const propTypes = {
  modalTitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  component: PropTypes.node.isRequired,
  componentKey: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  isSaveDisabled: PropTypes.bool,
  isSaving: PropTypes.bool,
};

const defaultProps = {
  modalTitle: 'Modal',
  componentKey: '',
  isSaveDisabled: false,
  isSaving: false,
};

const Modal = ({ modalTitle, isOpen, onClose, onOpen, onSaveClick, component, isSaveDisabled, isSaving }) => {
  useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen]);

  return (
    <div className="Modal">
      <ConstellationModal
        open={isOpen}
        size={{ base: 'fullScreen', md: 'md' }}
        useDismissProps={{
          outsidePress: false,
        }}
        onOpenChange={(open) => !open && onClose()}
        header={<Heading level={2}>{modalTitle}</Heading>}
        body={component}
        footer={
          <ButtonGroup aria-label="Actions">
            <TextButton onClick={onClose}>Cancel</TextButton>
            <Button tone="brand" emphasis="filled" onClick={onSaveClick} disabled={isSaveDisabled} loading={isSaving}>
              Save
            </Button>
          </ButtonGroup>
        }
      />
    </div>
  );
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;
